import React from 'react';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = ({ currentLanguage, onLanguageChange, scrollToSection, translations }) => {
    // Navigációs elemek ID-k szerint
    const navItems = [
        { id: 'hero', key: 'home' },
        { id: 'problems', key: 'problems' },
        { id: 'valve-neglect', key: 'valve_neglect' },
        { id: 'fake-solutions', key: 'fake_solutions' },
        { id: 'demands', key: 'demands' },
        { id: 'action', key: 'take_action' },
    ];

    return (
        <nav className="fixed top-0 w-full bg-dark-bg/95 backdrop-blur-sm border-b border-gray-900 z-50">
            <div className="section-container py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-8">
                        <div className="flex items-center space-x-2">
                            <div className="w-8 h-8 rounded-full bg-neon-red animate-pulse-neon"></div>
                            <span className="text-xl font-bold text-neon-red">FIXCS2NOW</span>
                        </div>

                        <div className="hidden md:flex space-x-6">
                            {navItems.map((item) => (
                                <button
                                    key={item.id}
                                    onClick={() => scrollToSection(item.id)}
                                    className="text-gray-300 hover:text-neon-red transition-colors relative group"
                                >
                                    {translations[item.key]}
                                    <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-neon-red group-hover:w-full transition-all duration-300"></span>
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="flex items-center space-x-4">
                        <LanguageSwitcher
                            currentLanguage={currentLanguage}
                            onLanguageChange={onLanguageChange}
                        />
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;